import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { HamButtonComponent } from '@modeso/aumico-components';
import i18next from 'i18next';

@Component({
    selector: 'user-filter-drop-down',
    templateUrl: './user-filter-drop-down.component.html',
    styleUrls: ['./user-filter-drop-down.component.scss'],
})
export class UserFilterDropDown implements OnChanges {
    @Input() label: string = 'aumico_pm_tasks_assignee_filter_label';
    @Input() users: { id: string; name: string }[] = [];
    @Input() selectedUserIds: string[] = [];
    @Input() currentUserId: string | null = null;
    @Input() view: 'tasks' | 'projects' | 'companies' = 'tasks';
    /** REV-22155: false for options that are not people (the tag filter) — no initials circle. */
    @Input() showAvatar = true;
    @Output() userChange = new EventEmitter<string[]>();
    @Output() searchChange = new EventEmitter<string>();

    filterIsActive: boolean = false;
    openedFlyout = false;

    flyoutPosition: { top: number; left: number; right: number } = { top: 0, left: 0, right: 0 };

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['selectedUserIds']) {
            this.updateFilterIsActive();
        }
    }

    private updateFilterIsActive(): void {
        this.filterIsActive = this.selectedUserIds?.length > 0;
    }

    onUserSelection(value: string, checked: boolean) {
        if (checked) {
            this.selectedUserIds.push(value);
        } else {
            this.selectedUserIds = this.selectedUserIds.filter((v) => v !== value);
        }
    }

    toggleUserSelection(userId: string): void {
        const isCurrentlySelected = this.selectedUserIds.includes(userId);
        this.onUserSelection(userId, !isCurrentlySelected);
    }

    getInitials(name: string): string {
        if (!name) return '';
        if (name === i18next.t('aumico_tasks_unassigned')) {
            return '-';
        }
        const parts = name.split(' ');
        return parts
            .map((p) => p[0])
            .join('')
            .toUpperCase();
    }

    openFlyout(buttonComponent: HamButtonComponent): void {
        const buttonElement = buttonComponent.nativeButton?.nativeElement;

        if (!buttonElement) return;

        const rect = buttonElement.getBoundingClientRect();

        this.flyoutPosition = {
            top: rect.bottom + 8, // Adjusted to add a small gap
            right: rect.right,
            left: rect.left,
        };

        this.openedFlyout = true;
    }

    closeFlyout(): void {
        this.openedFlyout = false;
    }

    clearFilter(): void {
        this.selectedUserIds = [];
        this.updateFilterIsActive();
        this.closeFlyout();
        this.userChange.emit(this.selectedUserIds);
        this.searchChange.emit('');
    }

    onSearchFilterChange(event) {
        this.searchChange.emit(event);
    }

    applyFilter(): void {
        this.updateFilterIsActive();
        this.closeFlyout();
        this.userChange.emit(this.selectedUserIds);
    }
}
